var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "nav_right",
    d: "M1.93255 0.849785L1.93257 0.849806L5.9808 4.90648C5.98086 4.90654 5.98092 4.9066 5.98098 4.90665C6.58384 5.50971 6.58375 6.49026 5.98079 7.09353L1.93255 0.849785ZM1.93255 0.849785C1.63385 0.550515 1.14911 0.55 0.849828 0.848675L1.93255 0.849785ZM0.848678 1.93144L0.848665 1.93143C0.550026 1.63214 0.550489 1.1474 0.849794 0.848709L0.848678 1.93144ZM0.848678 1.93144L4.89748 5.98868L4.89776 5.98896M0.848678 1.93144L4.89776 5.98896M4.89776 5.98896C4.89958 5.99078 4.90043 5.99227 4.90098 5.99362C4.90163 5.99523 4.90212 5.99738 4.90212 5.9999C4.90212 6.00242 4.90162 6.00463 4.90094 6.00632C4.90035 6.00776 4.89944 6.00937 4.89747 6.01134L4.89719 6.01162M4.89776 5.98896L4.89719 6.01162M4.89719 6.01162L0.848678 10.0686L0.848665 10.0686M4.89719 6.01162L0.848665 10.0686M0.848665 10.0686C0.550031 10.3679 0.550489 10.8526 0.849778 11.1513L0.848665 10.0686ZM1.93257 11.1502L5.98051 7.0938L0.849828 11.1513C0.999222 11.3004 1.1956 11.375 1.39062 11.375C1.58625 11.375 1.78309 11.3 1.93256 11.1502L1.66713 10.8853L1.93257 11.1502Z",
    fill: "#1E3799",
    stroke: "#1E3799",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavRight);
export default __webpack_public_path__ + "static/media/nav_right.cc327e3758f282e6c8dc99f5e3854f3c.svg";
export { ForwardRef as ReactComponent };